import { render, staticRenderFns } from "./CreateCombo.vue?vue&type=template&id=4038a552&scoped=true&"
import script from "./CreateCombo.vue?vue&type=script&lang=js&"
export * from "./CreateCombo.vue?vue&type=script&lang=js&"
import style0 from "./CreateCombo.vue?vue&type=style&index=0&id=4038a552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4038a552",
  null
  
)

export default component.exports